import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WorkspaceSettingsVisibilityPopoverContentUpdateVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Organization_Prefs_PermissionLevel"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"visibility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceSettingsVisibilityPopoverContentUpdateVisibility","document":WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityDocument}} as const;
export type WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
  visibility: Types.Organization_Prefs_PermissionLevel;
  traceId: Types.Scalars['String'];
}>;


export type WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation = (
  { __typename: 'Mutation' }
  & { updateOrganization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id'>
    & { prefs: (
      { __typename: 'Organization_Prefs' }
      & Pick<Types.Organization_Prefs, 'permissionLevel'>
    ) }
  )> }
);

export type WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationFn = Apollo.MutationFunction<
  WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation,
  WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationVariables
>;

/**
 * __useWorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation__
 *
 * To run a mutation, you first call `useWorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation, { data, loading, error }] = useWorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      visibility: // value for 'visibility'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useWorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation,
    WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation,
    WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationVariables
  >(WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityDocument, options);
}
export type WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationHookResult = ReturnType<
  typeof useWorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation
>;
export type WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationResult = Apollo.MutationResult<WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation>;
export type WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationOptions = Apollo.BaseMutationOptions<
  WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutation,
  WorkspaceSettingsVisibilityPopoverContentUpdateVisibilityMutationVariables
>;
